import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { RectShape, RectHollow } from '../shape';
import { MaybeZeroY1 } from '../transform';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip1d } from './utils';
var shape = {
  rect: RectShape,
  hollow: RectHollow
};
export var Rect = function Rect() {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      X1 = value.x1,
      Y = value.y,
      Y1 = value.y1;
    var P = Array.from(index, function (i) {
      var p1 = [+X[i], +Y[i]];
      var p2 = [+X1[i], +Y[i]];
      var p3 = [+X1[i], +Y1[i]];
      var p4 = [+X[i], +Y1[i]];
      return [p1, p2, p3, p4].map(function (d) {
        return coordinate.map(d);
      });
    });
    return [index, P];
  };
};
Rect.props = {
  defaultShape: 'rect',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeZeroY1
  }]),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip1d())),
  interaction: {
    shareTooltip: true
  }
};